import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api_call from "../../../globals/common_utilities/axios_old";
import CONSTANTURL from "../../../globals/common_utilities/constanturls";
import { API } from "../../../globals/constants";

const initialState = {
  loading: false,
  data: [],
  error: "",
  ImageCreator: [],
  ImageData:[],
  TestImage:[],
  ConfirmImage:[],
  ImageByIdData:[]
};

export const ImageConfigList = createAsyncThunk(
  "image_Listing/api",
  ({ token, params }) => {
    return api_call(
      "get",
      `${
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
        API.END_POINTS.IMAGECONFIGURATOR_LIST
      }`,
      params,
      {},
      {}
    );
  }
);
const imageConfiguartorListingSlice = createSlice({
  name: "image_List",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(ImageConfigList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(ImageConfigList.fulfilled, (state, action) => {
      state.loading = false;
      state.ImageListingResponse = action.payload;
      state.error = "";
    });
    builder.addCase(ImageConfigList.rejected, (state, action) => {
      state.loading = false;
      state.ImageListingResponse = [];
      state.error = action.error.message;
    });
  },
});

export const ImageByIdData = createAsyncThunk(
  "imageListing/api",
  ({ token, params }) => {
    return api_call(
      "get",
      `${
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
        API.END_POINTS.GET_IMAGE_BY_ID
      }`,
      params,
      {},
      {}
    );
  }
);
const imageByIdDataSlice = createSlice({
  name: "imageconfiglist",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(ImageByIdData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(ImageByIdData.fulfilled, (state, action) => {
      state.loading = false;
      state.ImageByIdData = action.payload;
      state.error = "";
    });
    builder.addCase(ImageByIdData.rejected, (state, action) => {
      state.loading = false;
      state.ImageByIdData = [];
      state.error = action.error.message;
    });
  },
});
export const ImageCreator = createAsyncThunk(
  "createImage/Redux_createImage",
  ({ token,bodyParam }) => {
    return api_call(
      "POST",
      `${
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
        API.END_POINTS.CREATE_IMAGE
      }`,
      {},
      {},
      bodyParam
    );
  }
);

const addImage = createSlice({
  name: "createImage",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(ImageCreator.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(ImageCreator.fulfilled, (state, action) => {
      state.loading = false;
      state.ImageCreator = action.payload;
      state.error = "";
    });
    builder.addCase(ImageCreator.rejected, (state, action) => {
      state.loading = false;
      state.ImageCreator = [];
      state.error = action.error.message;
    });
  },
});
export const TestImage = createAsyncThunk(
  "testImage/Redux_testImage",
  ({ token,bodyParam }) => {
    return api_call(
      "POST",
      `${
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
        API.END_POINTS.TEST_IMAGE
      }`,
      {},
      {},
      bodyParam
    );
  }
);

const testImage = createSlice({
  name: "testImage",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(TestImage.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(TestImage.fulfilled, (state, action) => {
      state.loading = false;
      state.TestImage = action.payload;
      state.error = "";
    });
    builder.addCase(TestImage.rejected, (state, action) => {
      state.loading = false;
      state.TestImage = [];
      state.error = action.error.message;
    });
  },
});


export const ConfirmImage = createAsyncThunk(
  "confirmImage/Redux_confirmImage",
  ({ token,bodyParam }) => {
    return api_call(
      "POST",
      `${
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
        API.END_POINTS.CONFIRM_IMAGE
      }`,
      {},
      {},
      bodyParam
    );
  }
);

const confirmImageSlice = createSlice({
  name: "confirmImage",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(ConfirmImage.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(ConfirmImage.fulfilled, (state, action) => {
      state.loading = false;
      state.ConfirmImage = action.payload;
      state.error = "";
    });
    builder.addCase(ConfirmImage.rejected, (state, action) => {
      state.loading = false;
      state.ConfirmImage = [];
      state.error = action.error.message;
    });
  },
});
export const ImageStatus = createAsyncThunk(
  "imageStatus/api",
  ({ token, statusParams }) => {
    return api_call(
      "get",
      `${
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
        API.END_POINTS.IMAGE_STATUS
      }`,
      statusParams,
      {},
      {}
    );
  }
);
const imageStatusSlice = createSlice({
  name: "imageconfig",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(ImageStatus.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(ImageStatus.fulfilled, (state, action) => {
      state.loading = false;
      state.ImageStatus = action.payload;
      state.error = "";
    });
    builder.addCase(ImageStatus.rejected, (state, action) => {
      state.loading = false;
      state.ImageStatus = [];
      state.error = action.error.message;
    });
  },
});
export const ImageConfiguartor = {
  ImageConfiguratorList: imageConfiguartorListingSlice.reducer,
  ImageConfig: addImage.reducer,
  ImageStatus: imageStatusSlice.reducer,
  ImageByIdData: imageByIdDataSlice.reducer,
  TestImage: testImage.reducer,
  ConfirmImage: confirmImageSlice.reducer,
};
